import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ReachStorage } from '~app-client/core/utils';

@Injectable({ providedIn: 'root' })
export class SidenavService {
	private static getCollapsedStoredValue(): boolean {
		const stored = ReachStorage.getItem<boolean>(SidenavService.collapsedStoreKey);
		return stored === true;
	}

	private static setCollapsedStoredValue(collapsed: boolean): void {
		ReachStorage.setItem(SidenavService.collapsedStoreKey, collapsed);
	}

	private static collapsedStoreKey = '__home_sidebar_collapsed';

	public readonly collapsed$$ = new BehaviorSubject(SidenavService.getCollapsedStoredValue());
	public readonly collapsed$ = this.collapsed$$.asObservable();

	public toggleCollapsedStatus(value?: boolean): void {
		const next = value ?? !this.collapsed$$.value;
		SidenavService.setCollapsedStoredValue(next);
		this.collapsed$$.next(next);
	}
}
